module.exports = "/images/ma.svg?0e5896ed7ab7fae3d077ce0e823d0197";